goog.provide('el8.print.rxReportOH');

goog.require('el8.appservice.status');
goog.require('el8.data.init');
goog.require('el8.data.physicians');
goog.require('el8.data.practices');
goog.require('el8.data.practiceSettings');
goog.require('el8.ptdata.patients');
goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.service.tz');
goog.require('el8.template.print.rxReportOH');
goog.require('el8.util.print');


el8.print.rxReportOH.init = function(spec) {
    el8.appservice.status.init();

    if (spec.data) { el8.data.init(spec.data); }
    var medorders = spec.medorders.map(function(m) {
        var med = el8.ptdata.model.med.medOrder(m).asSoyMap();
        med.patient = el8.ptdata.patients.getByIdIncludingDeleted(med.patientId).asSoyMap();
        med.prescribingPhysician = el8.data.physicians.getById(med.prescribingPhysicianId).asSoyMap();
        return med;
    });

    $('.print-content').replaceWith(
        el8.template.print.rxReportOH.content({
            practice: el8.data.practices.create(spec.practice).asSoyMap(),
            physician: el8.data.physicians.create(spec.physician).asSoyMap(),
            startDate: spec.startDate,
            endDate: spec.endDate,
            medorders: medorders,
            now: el8.service.tz.asServerFormatDateTime(el8.service.tz.now())
        })
    );

    el8.util.print.pageSetup();
};

